import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import FilterMenuSearchLookupLegacy from './_do_not_import_/FilterMenuSearchLookup';
import FilterMenuSearchLookupV2, { IFilterMenuSearchLookupProps } from './_do_not_import_v2_/FilterMenuSearchLookup';

export const FilterMenuSearchLookup = (props: IFilterMenuSearchLookupProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <FilterMenuSearchLookupV2 {...props} />;
  }

  return <FilterMenuSearchLookupLegacy {...props} />;
};
